"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeToggleButtonStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeToggleButtonStyles = function makeToggleButtonStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiToggleButton: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["body-copy-small"]), {}, {
          color: tokens.colors["ink-on-background-60"].rgb,
          fontWeight: primitives.fontWeights.stout,
          padding: "4.5px ".concat(primitives.spacings["4"]),
          border: "none",
          boxSizing: "border-box",
          "&:hover": {
            backgroundColor: tokens.colors["hover-fill-subtle"].rgb
          },
          "&:active": {
            backgroundColor: tokens.colors["pressed-fill-subtle"].rgb,
            border: "none"
          },
          "&.Mui-selected": {
            backgroundColor: tokens.colors["fill-elevation-2"].rgb,
            color: tokens.colors["ink-on-background"].rgb,
            "&:hover": {
              backgroundColor: tokens.colors["fill-elevation-2"].rgb
            }
          },
          "&.Mui-disabled": {
            border: "none",
            color: tokens.colors["detail-1-transparent"].rgb
          }
        }),
        sizeSmall: {
          fontSize: primitives.fontSizes["1"],
          padding: "3px ".concat(primitives.spacings["3"])
        }
      }
    }
  };
};

exports.makeToggleButtonStyles = makeToggleButtonStyles;